import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Fong is a backend engineer working at meepShop. He is also the speaker and volunteer in the DDDTW community. He loves to share knowledge with others through communicating and writing. He also had two series of articles on ITHelp website: Think in GraphQL and Think in DDD.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      